"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var locationsCarousel = document.querySelectorAll('.locations-carousel');
  if (locationsCarousel.length > 0) {
    var locationSliders = document.querySelectorAll('.locations-carousel__container');
    for (var i = 0; i < locationSliders.length; i++) {
      var locationsGlide = new Glide(locationSliders[i], {
        type: 'carousel',
        autoplay: 5500,
        hoverpause: false,
        animationDuration: 750,
        animationTimingFunc: 'ease-in-out',
        gap: 0,
        startAt: 0,
        perView: 1
      });
      var mediaQueryBelow = window.matchMedia('(max-width: 1023px)');
      if (mediaQueryBelow.matches) {
        locationsGlide.disable();
      } else {
        locationsGlide.mount();
      }
    }
  }
});